import $ from 'jquery'

import form from '../../edit/form/form'

import documentInsert from '../../lib/documentInsert'
import documentUpdate from '../../lib/documentUpdate'

export function getName(){
  return 'archive/roll'
}

var aMarkersByRoll = null
var aaMarkersByRoll = null
var aTagsById = null
var aaTagsById = null

export function getTableColumns(o,item){

  var lang = o.store('lang')

  var aMarkerTags = _.map(aMarkersByRoll[item.roll], 'tag')
  if(!aMarkerTags){ aMarkerTags = [] }

  var aMarkerTexts = _.compact(_.map(aMarkerTags, function(tagId){
    if(aTagsById[tagId]){
      var tagItem = aTagsById[tagId][0]
    }
    if(tagItem){
      return tagItem[lang]
    } else {
      console.log("archive tag not found", item, tagId)
      return null
    }
  }))

  var aaMarkerTags = _.map(aaMarkersByRoll[item.roll], 'tag')
  if(!aaMarkerTags){ aaMarkerTags = [] }

  var aaMarkerTexts = _.compact(_.map(aaMarkerTags, function(tagId){
    if(aaTagsById[tagId]){
      var tagItem = aaTagsById[tagId][0]
    }
    if(tagItem){
      return tagItem[lang]
    } else {
      console.log("archive tag not found", item, tagId)
      return null
    }
  }))

  var itemProject = item.roll.split('-')[0]

  var contributor =
    _.find(o.data.contributors, function(contributor){
      return contributor.project == itemProject
    })

  var contributorString =
    contributor.firstName[0] + '. ' +
    contributor.lastName + ', ' +
    contributor.city

  var columns = [
    {
      id: 'roll',
      value: item.roll,
      type: o.type.text,
      width: 75,
    },
    {
      id: 'filmType',
      value: item.filmType,
      type: o.type.text,
      width: 50,
    },
    {
      id: 'years',
      value: item.years,
      type: o.type.years,
      width: 125,
    },
    {
      id: 'archiveMarkers',
      value: aMarkerTexts,
      type: o.type.list,
      width: 300,
      multiline: true,
    },
    {
      id: 'totalArchiveMarkers',
      value: aMarkerTags.length,
      type: o.type.number,
      width: 60,
      auth: ['admin','author'],
    },
    {
      id: 'antiArchiveMarkers',
      value: aaMarkerTexts,
      type: o.type.list,
      width: 300,
      multiline: true,
      auth: ['admin','author'],
    },
    {
      id: 'totalAntiArchiveMarkers',
      value: aaMarkerTags.length,
      type: o.type.number,
      width: 60,
      auth: ['admin','author'],
    },
    {
      id: 'duration',
      value: item.duration,
      type: o.type.timecode,
      optional: true,
    },
    {
      id: 'contributor',
      value: contributorString,
      type: o.type.text,
      auth: ['admin'],
    },
    {
      id: 'notes',
      value: item.notes,
      type: o.type.textLong,
      width: 300,
      multiline: true,
      auth: ['admin','author'],
    },
    {
      id: 'user',
      value: item.user,
      type: o.type.text,
      auth: ['admin','author'],
    },
    {
      id: 'date',
      value: item.date,
      type: o.type.date,
      auth: ['admin','author'],
    },
  ]

  return columns

}

export function getTableData(o){

  aMarkersByRoll = _.groupBy(o.data.archive.markers,'roll')
  aaMarkersByRoll = _.groupBy(o.data.antiArchive.markers,'roll')
  aTagsById = _.groupBy(o.data.archive.tags,'_id')
  aaTagsById = _.groupBy(o.data.antiArchive.tags,'_id')

  var data =
    _.map(

      o.data.rolls,

      function(item){

        var model = o.model.rollsData
        var columns = model.getTableColumns(o,item)

        var click =
          function(){
            o.player.load(item)
            o.edit.set(item,model)
          }

        return {
          columns: columns,
          click: click,
        }

      }
    )

  return data

}

export function getFormFields(o,item){

  var lang = o.store('lang')

  var fields = [
    {
      id: 'roll',
      value: item.roll,
      type: 'text',
    },
    {
      id: 'filmType',
      value: item.filmType,
      type: 'text',
      optional: true,
      edit: true,
    },
    {
      id: 'notes',
      value: item.notes,
      type: 'textLong',
      optional: true,
      edit: true,
    },
    {
      id: 'years',
      value: item.years,
      type: 'years',
      optional: true,
      edit: true,
    },
    {
      id: 'author',
      value: item.author,
      type: 'text',
      edit: true,
    },
  ]

  return fields

}

export function insertForm(o,done){

}

export function insert(o,item,done){

  var data = o.data.rolls
  var collection = 'rolls'

  documentInsert(o,data,item,collection,done)

}

export function update(o,id,changes,done){

  var lang = o.store('lang')

  var data = o.data.rolls
  var collection = 'rolls'

  var tagsChange = _.find(changes,{id: 'tags'})
  if(tagsChange){
    tagsChange.value =_.map(tagsChange.value,function(tag){
      var tag = _.find(o.data.archive.tags,{[lang]: tag})
      if(tag){
        return tag._id
      }
      return
    })
  }

  var placesChange = _.find(changes,{id: 'places'})
  if(placesChange){
    placesChange.value =_.map(placesChange.value,function(place){
      var place = _.find(o.data.archive.places,{[lang]: place})
      if(place){
        return place._id
      }
      return
    })
  }

  changes.push({
    id: 'user',
    value: o.store('email'),
  })

  changes.push({
    id: 'date',
    value: new Date(),
  })

  documentUpdate(o,data,id,changes,collection,done)

}



// WEBPACK FOOTER //
// ./src/client/view/admin/model/rollsData/rollsData.js